import React from "react";
import Hero from "../../../../components/Hero";

function HeaderTemplate() {
  return <Hero />;
}

export default HeaderTemplate;
